import { ConnectedProps, connect } from 'react-redux'
import { ButtonPrimaryInfoLeft, ButtonSecondaryInfoLeft } from '../../../../../../baseComponents/Button'
import { ComponentWithPermissions } from '../../../../../../baseComponents/CreateRoutering/types'
import PermissionChecker from '../../../../../../baseComponents/PermissionChecker'
import { BaseScreenTableSimpleStateless, useBaseScreenTableLogic } from '../../../../../../baseComponents/TwinTable/BaseScreenTable'
import { BaseScreenPageData } from '../../../../../../baseComponents/TwinTable/BaseScreenTable/types'
import withLoading from '../../../../../../utils/hoc/withLoading'
import useEditDeleteModal, { SetEditDeleteModalTy } from '../../../../../../utils/hooks/useEditDeleteModal'
import useTwinTranslation from '../../../../../../utils/hooks/useTwinTranslation'
import useUpdateTableInstance from '../../../../../../utils/hooks/useUpdateTableInstance'
import { AllReduxPayloads } from '../../../../../../utils/reducers'
import { BrandsPayload } from '../../../../../../utils/reducers/products/brands'
import { CategoriesPayload } from '../../../../../../utils/reducers/products/categories'
import { SpecificPriceRulesPayload } from '../../../../../../utils/reducers/products/specificPriceRules'
import ModalChangeActiveProduct from './ModalChangeActiveProduct'
import ModalCreateProductConnect from './ModalCreateProduct'
import TableProducts from '../../../../../../specificComponents/Product/Tables/TableProducts'
import { faPlus } from '@fortawesome/pro-light-svg-icons'
import TwinIcon from '../../../../../../baseComponents/TwinIcon'
import ModalImportProducts from './ModalImportProducts'
import { getConfigParam, getUserPermissions } from '../../../../../../utils/reducers/getters'
import { useCallback, useMemo } from 'react'
import { ButtonsModalSmallCentered, ModalSmallCentered } from '../../../../../../baseComponents/Modal'
import { t } from 'i18next'
import TwinTrans from '../../../../../../baseComponents/TwinTrans'
import { ModalEditComponentProps } from '../../../../../../baseComponents/ModalsLayouts/types'
import useIsLoading from '../../../../../../utils/hooks/useIsLoading'
import { twinFetchPostText } from '../../../../../../utils/globals/data'
import { CollectionsPayload } from '../../../../../../utils/reducers/products/collections'
import './products.sass'

type ProductsProps = ComponentWithPermissions & ReduxProducts & {}

const Products: React.FC<ProductsProps> = ({ userPermissions, ...button }) => {
    const { t } = useTwinTranslation()
    const { openModal, setOpenModal, tableInstance, setTableInstance } = useBaseScreenTableLogic()
    const { updateTableInstance } = useUpdateTableInstance({ tableInstance })
    const pageData = {
        title: t('products', 'Productos'),
        newText: t('newProduct', 'Nuevo producto'),
    }

    return (
        <BaseScreenTableSimpleStateless TableComponent={TableProductsConnect} {...{ pageData, userPermissions, updateTableInstance }} CreateModalComponent={ModalCreateProductConnect} EditModalComponent={ModalImportProducts} DeleteModalComponent={ModalChangeActiveProduct} logicProps={{ openModal, setOpenModal, tableInstance, setTableInstance }} RightHeader={
            <RightHeaderProductTable {...{ pageData, setOpenModal, ...button, userPermissions, updateTableInstance }} />
        }>
        </BaseScreenTableSimpleStateless>
    )
}

const productsDispatch = {
    setSpecificPriceRules: (payload: SpecificPriceRulesPayload) => ({ type: 'CHANGE_SPECIFICPRICERULES', payload }),
}
const mapProductsConnector = (state: AllReduxPayloads) => ({ specificPriceRules: state.specificPriceRules })
const productsConnect = connect(mapProductsConnector, productsDispatch)
type ReduxProducts = ConnectedProps<typeof productsConnect>

const ProductsConnectLoading = withLoading(Products, [{ fetchUrl: '/api/app/product/specificPrice/getAllSpecificPriceRules', propName: 'specificPriceRules', setFunctionName: 'setSpecificPriceRules' }])
const ProductsConnect = productsConnect(ProductsConnectLoading)


type RightHeaderProductTableProps = ReduxProducts & {
    pageData: BaseScreenPageData
    setOpenModal: SetEditDeleteModalTy
    updateTableInstance: () => void
}

const RightHeaderProductTable: React.FC<RightHeaderProductTableProps> = ({ pageData, specificPriceRules, setOpenModal, updateTableInstance }) => {
    const { t } = useTwinTranslation()
    const editModalInner = useEditDeleteModal()
    const haveWordpress = useMemo(() => getConfigParam('wordpressSpecificRuleId'), [])
    return (
        <div className='flex items-center ml-auto'>
            <PermissionChecker userPermissions={getUserPermissions('productOther.importProducts')} permission='read'>
                {haveWordpress ? <ButtonSecondaryInfoLeft textButton={t('importWordpressProducts', 'Importar productos wordpress')} className='mr-10' onClick={() => { editModalInner.setOpenModal({ type: 'edit', allRowData: {} }) }} buttonIsDisabled={specificPriceRules?.arrSorted?.length === undefined || specificPriceRules?.arrSorted?.length === 0} infoMessage={t('needCreatePriceRulesBefore', 'Debes crear un grupo de tarifas antes')}/> : null}
                <ButtonSecondaryInfoLeft textButton={t('importProducts', 'Importar productos')} className='mr-10' onClick={() => { setOpenModal({ type: 'edit', allRowData: {} }) }} buttonIsDisabled={specificPriceRules?.arrSorted?.length === undefined || specificPriceRules?.arrSorted?.length === 0} infoMessage={t('needCreatePriceRulesBefore', 'Debes crear un grupo de tarifas antes')}/>
            </PermissionChecker>
            {pageData.newText ? <ButtonPrimaryInfoLeft onClick={async () => setOpenModal({ type: 'create', allRowData: {} })} textButton={<span><TwinIcon icon={faPlus} className='mr-8' />{pageData.newText}</span>} buttonIsDisabled={specificPriceRules?.arrSorted?.length === undefined || specificPriceRules?.arrSorted?.length === 0} infoMessage={t('needCreatePriceRulesBefore', 'Debes crear un grupo de tarifas antes')} /> : null}
            {editModalInner.openModal?.type === 'edit' ? <ModalImportWordpressProducts setOpened={() => editModalInner.setOpenModal(null)} onSubmit={updateTableInstance}/> : null}
        </div>
    )
}

interface ModalImportWordpressProductsProps extends ModalImportWordpressProductsLogicProps {
}

const ModalImportWordpressProducts: React.FC<ModalImportWordpressProductsProps> = ({setOpened, ...rest}) => {
    const { loading, importProducts } = useModalImportWordpressProductsLogic({setOpened, ...rest})
    return (
        <ModalSmallCentered opened={true} setOpened={setOpened} onClickOut={false}>
            <h2><TwinTrans transKey='importProducts'>Importar productos</TwinTrans></h2>
            <span> <TwinTrans transKey='sureImportWordpressProducts'>¿Seguro que quieres importar los productos desde wordpress?</TwinTrans></span>
            <ButtonsModalSmallCentered loading={loading} confirmText={t('accept', 'Aceptar')} setOpened={() => setOpened(null)} onAccept={importProducts}></ButtonsModalSmallCentered>
        </ ModalSmallCentered>
    )
}

interface ModalImportWordpressProductsLogicProps extends ModalEditComponentProps {
}

const useModalImportWordpressProductsLogic = ({onSubmit, setOpened}: ModalImportWordpressProductsLogicProps) => {
    const {endLoading, loading, startLoading} = useIsLoading()
    const importProducts = useCallback(async () => {
        startLoading()
        const res = await twinFetchPostText('/api/app/product/importProductsFromWordpressFirstPart', {})
        if(res){
            const res2 = await twinFetchPostText('/api/app/product/importProductsFromWordpress', {})
            await onSubmit?.(res2, {})
        }
        endLoading()
        setOpened(null)
    }, [startLoading, endLoading, setOpened, onSubmit])
    return { loading, importProducts }
}


const tableProductsDispatch = {
    setCategories: (payload: CategoriesPayload) => ({ type: 'CHANGE_CATEGORIES', payload }),
    setBrands: (payload: BrandsPayload) => ({ type: 'CHANGE_BRANDS', payload }),
    setCollections: (payload: CollectionsPayload) => ({ type: 'CHANGE_COLLECTIONS', payload }),
}
const mapTableProductsConnector = (state: AllReduxPayloads) => ({ categories: state.categories, brands: state.brands, collections: state.collections})
const tableProductsConnect = connect(mapTableProductsConnector, tableProductsDispatch)

const tableProductsConnectLoading = withLoading(TableProducts, [{ fetchUrl: '/api/app/product/category/getAllCategories', propName: 'categories', setFunctionName: 'setCategories' }, { fetchUrl: '/api/app/product/brand/getAllBrands', propName: 'brands', setFunctionName: 'setBrands' }, { fetchUrl: '/api/app/product/collection/getAllCollections', propName: 'collections', setFunctionName: 'setCollections' }])
const TableProductsConnect = tableProductsConnect(tableProductsConnectLoading)

export default ProductsConnect